import React, { useState, useRef, useEffect, Fragment } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
    // setCalculatorField, // ADREC: Mortgage Calculator removed
    toggleFavouriteStatus,
} from "../../../redux/slice/buyerSlice";
import { removeFavourite } from "../../../redux/slice/profileSlice";
import { togglePropertyLike } from "../../../redux/action/sellerAction";
import { toggleBidFavouriteStatus } from "../../../redux/slice/bidSlice";
import DOMPurify from "dompurify";
// ADREC: ABUDHABICITYID orphaned by the removed Analytics Area section. Original:
// import {
//     ABUDHABICITYID,
//     SELLER_PROPERTY_STATUS,
// } from "../../../utils/constants";
import { SELLER_PROPERTY_STATUS } from "../../../utils/constants";
// import { Link } from "react-router-dom";  // ADREC: orphaned (Map View)
import { guessDateTime } from "../../../utils/dateUtils";
import {
    formatPrice,
    formatNumber,
    createSlug,
    getPropertyStatus,
    getLotStatus,
    toEasternArabicNumerals,
} from "../../../helpers";
import AuctionBidding from "./right-panel/AuctionBidding";
import AuctionBiddingSeller from "../../seller/property-details/right-panel/AuctionBidding";
import Gallery from "./Gallery";
// import ShareButton from "../../common/ShareButton"; // ADREC: Share icon removed
import SocketService from "../../../Service/SocketService";
import useTranslationHook from "../../hooks/useTranslationHook";
import {
    handleChat,
    handleSelectedUser,
    setIsChatInitiated,
    setSellerDetail,
} from "../../../redux/slice/inboxSlice";
import {
    handleContactUsModal,
    handleRetractBidModal,
} from "../../../redux/slice/modalSlice";
import ContactUsModal from "../../common/ContactUsModal";
// import SimilarProperties from "./SimilarProperties";  // ADREC: orphaned
import RetractBidModal from "./right-panel/modals/RetractBidModal";
// import { SaleTrendChart } from "../../common/SaleTrendChart";  // ADREC: orphaned (Analytics)
// import { AveragePriceChart } from "../../common/AveragePriceChart";  // ADREC: orphaned (Analytics)
// import AreaComparision from "../../common/AreaComparision";  // ADREC: orphaned (Analytics)
import PaymentFailureModal from "./right-panel/modals/PaymentFailureModal";
// import Faq from "./Faq";  // ADREC: orphaned (Buying-with-brand)
// import MortgageCalculator from "./MortgageCalculator"; // ADREC: Mortgage Calculator removed
// import { downloadFile } from "../../../utils";  // ADREC: orphaned
import BidHistory from "../../seller/property-details/right-panel/BidHistory";
import ScrollTabs from "./ScrollTabs";
// import TimeSlotModal from "./TimeSlotModal";  // ADREC: orphaned (Map View)
import Slider from "react-slick";
import { initiatePurchase } from "../../../redux/action/paymentAction";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import { handleSiteLoader } from "../../../redux/action/authAction";
// ADREC: setPreferredTime orphaned by the removed Map View section. Original:
// import {
//     sendValuationDocument,
//     setPreferredTime,
// } from "../../../redux/action/buyerAction";
import { sendValuationDocument } from "../../../redux/action/buyerAction";
import { Trans } from "react-i18next";
// import DetailsMapComponent from "../../common/DetailsMapComponent";  // ADREC: orphaned (Map View)
const Details = ({ propertyDetail, from }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslationHook();
    const [showTabs, setShowTabs] = useState(false);
    // const [showModal, setShowModal] = useState(false);  // ADREC: orphaned (Map View)
    const [activeTab, setActiveTab] = useState("disclaimer");
    let lang = useSelector((state) => state.translation.lang);
    // ADREC: the three quantaNoData flags only gated the Analytics Area section.
    // const noDataAreaComparison = useSelector(
    //     (state) => state.buyer.quantaNoData.noDataAreaComparison
    // );
    // const noDataSaleTrends = useSelector(
    //     (state) => state.buyer.quantaNoData.noDataSaleTrends
    // );
    // const noDataAveragePrice = useSelector(
    //     (state) => state.buyer.quantaNoData.noDataAveragePrice
    // );

    const modalRef = useRef(null);
    const {
        id: propertyId,
        project_name,
        project_name_ar,
        property_name_ar,
        property_pic,
        property_doc,
        property_video,
        description,
        description_ar,
        construction_status_name,
        property_name,
        // country,  // ADREC: orphaned by removed sections
        community,
        community_ar,
        is_map_view,
        square_footage,
        // beds,  // ADREC: removed (residential — N/A for land plots)
        // baths, // ADREC: removed (residential — N/A for land plots)
        // amenities,  // ADREC: orphaned by removed sections
        // tags,  // ADREC: removed (residential feature tags)
        property_project_data: projectData,
        added_on,
        deposit_amount,
        listed_by,
        property_setting,
        is_favourite,
        property_auction_data,
        agent_id,
        property_for,
        is_chat_initiated,
        seller_status_id,
        seller_status_name,
        // city,  // ADREC: orphaned by removed sections
        map_url: googleMapsUrl,
        payment_failed_status,
        payment_failed_message,
        payment_error_text,
        reg_transaction_id,
        purchase_forefit_status,
        // inspection_report,  // ADREC: orphaned by removed sections
        // buying_with_mazad,  // ADREC: orphaned by removed sections
        disclaimer_licence_info,
        valuation_fee,
        valuation_fee_paid,
        valuation_report_uploaded,
        district,
        district_ar,
        municipality,
        municipality_ar,
        session_status,
        lot_status,
        lot_pause_resume,
        visibility,
    } = propertyDetail;
    const { account: isSeller } = useSelector((state) => state.profile);
    const retractBidModal = useSelector((state) => state.modal.retractBidModal);
    // ADREC: Mortgage Calculator removed — calculator state no longer read.
    // const { buyerType, downPayment, interest, price, tenure } = useSelector(
    //     (state) => state.buyer.calculator
    // );

    const paymentId = useSelector(
        (state) => state.payment.paymentId,
        shallowEqual
    );
    const paymentUrl = useSelector(
        (state) => state.payment.paymentUrl,
        shallowEqual
    );

    const getStatus = (id, name) => ({
        label: id !== 27 ? name : "loading...",
        className:
            id === 27 || id === 28
                ? "active"
                : id === 29
                  ? "upcomingclr"
                  : "grayclr",
    });

    const [bidHistoryData, setBidHistoryData] = useState({
        biddingData: null,
        auctionStatus: null,
    });

    const { biddingData, auctionStatus } = bidHistoryData;

    const handleBidHistoryChange = (data) => {
        setBidHistoryData((prev) => ({
            ...prev,
            ...data,
        }));
    };

    const [propertyCurrentStatus, setPropertyCurrentStatus] = useState(
        getStatus(seller_status_id, seller_status_name)
    );
    const [showFailureModal, setShowFailureModal] = useState(false);
    useEffect(() => {
        setShowFailureModal(!!payment_failed_status);
    }, [payment_failed_status]);
    const [isLiked, setIsLiked] = useState(is_favourite || false);
    const [purchaseForefitStatus, setPurchaseForefitStatus] = useState(
        purchase_forefit_status || null
    );
    const [offerUserId, setOfferedUserId] = useState(null);
    const [isRetracted, setIsRetracted] = useState(false);
    const [statusMessage, setStatusMessage] = useState(0);
    const user = useSelector((state) => state.auth.user);
    const { isConnected } = useSelector((state) => state.socket);
    const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
    // const [selectedImage, setSelectedImage] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const descRef = useRef(null);
    const sanitizedDescription = () => ({
        __html: DOMPurify.sanitize(
            lang === "en" ? description : description_ar || "",
            { FORBID_ATTR: ["style", "dir"] }
        ),
    });

    const sanitizedDisclaimer = () => ({
        __html: DOMPurify.sanitize(
            lang === "en"
                ? disclaimer_licence_info?.disclaimer
                : disclaimer_licence_info?.disclaimer_ar || ""
        ),
    });

    const sanitizedLicense = () => ({
        __html: DOMPurify.sanitize(
            lang === "en"
                ? disclaimer_licence_info?.licence
                : disclaimer_licence_info?.licence_ar || ""
        ),
    });

    // const [isAmenitiesExpanded, setIsAmenitiesExpanded] = useState(false);  // ADREC: orphaned (Amenities)

    const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(false);
    const [showDisclaimerButton, setShowDisclaimerButton] = useState(false);

    const [isLicenseExpanded, setIsLicenseExpanded] = useState(false);
    const [showLicenseButton, setShowLicenseButton] = useState(false);

    const disclaimerRef = useRef(null);
    const licenseRef = useRef(null);

    // useDidMountEffect(() => {
    //     if (paymentUrl && paymentId) dispatch(handleSiteLoader(true));
    //     requestAnimationFrame(
    //         () =>
    //             (window.location.href = `${paymentUrl}?PaymentID=${paymentId}`)
    //     );
    //     return () => {
    //         dispatch(handleSiteLoader(false));
    //     };
    // }, [paymentId, paymentUrl]);

    useEffect(() => {
        if (disclaimerRef.current && activeTab === "disclaimer") {
            const el = disclaimerRef.current;
            setShowDisclaimerButton(el.scrollHeight > el.clientHeight);
        }

        if (licenseRef.current && activeTab === "license") {
            const el = licenseRef.current;
            setShowLicenseButton(el.scrollHeight > el.clientHeight);
        }
    }, [activeTab, disclaimer_licence_info, lang]);

    useEffect(() => {
        setIsDisclaimerExpanded(false);
        setIsLicenseExpanded(false);
    }, [activeTab]);

    useEffect(() => {
        if (descRef.current) {
            setShowButton(
                descRef.current.scrollHeight > descRef.current.clientHeight
            );
        }
    }, [description, lang]);

    useEffect(() => {
        const handleScroll = () => {
            setShowTabs(window.scrollY >= 200);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // useEffect(() => {
    //     // if (!isAuthenticated) {
    //     //     toast.info(t("Please sign in to contact the seller."));
    //     //     navigate("/sign-in");
    //     //     return;
    //     // }
    //     const queryParams = new URLSearchParams(location.search);
    //     const buyNow = queryParams.get("buy_now");
    //     const success = queryParams.get("success");
    //     if (buyNow === "false") {
    //         setShowFailureModal(true);
    //         queryParams.delete("buy_now");
    //         navigate(
    //             {
    //                 pathname: location.pathname.endsWith("/")
    //                     ? location.pathname.slice(0, -1)
    //                     : location.pathname,
    //                 search: queryParams.toString()
    //                     ? `?${queryParams.toString()}`
    //                     : "",
    //             },
    //             { replace: true }
    //         );
    //     }
    // }, [isAuthenticated, location.search, location.pathname, navigate]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const buyNow = queryParams.get("buy_now");
        const success = queryParams.get("success");
        if (buyNow === "false" || success === "false") {
            setShowFailureModal(true);
        }
        if (success === "true") {
            if (propertyId) dispatch(sendValuationDocument(propertyId, "", t));
        }
        if (buyNow === "false" || ["true", "false"].includes(success)) {
            queryParams.delete("buy_now");
            queryParams.delete("success");
            navigate(
                {
                    pathname: location.pathname.replace(/\/$/, ""),
                    search: queryParams.toString()
                        ? `?${queryParams.toString()}`
                        : "",
                },
                { replace: true }
            );
        }
    }, [location.search, location.pathname, navigate]);

    const floorPlan =
        property_doc?.filter((doc) => doc.upload_identifier === 3)?.[0] ?? null;

    const openGoogleMaps = () => {
        if (!googleMapsUrl) return;
        window.open(googleMapsUrl, "_blank");
    };

    const submitReaction = () => {
        setIsLiked((prev) => !prev);
        dispatch(toggleFavouriteStatus(propertyId));
        dispatch(toggleBidFavouriteStatus(propertyId));
        const formData = {
            domain: 3,
            property: propertyId,
            ...(user?.user_id && { user: Number(user.user_id) }),
        };
        dispatch(togglePropertyLike(formData));
        toast.success(
            t(`${isLiked ? "Removed from" : "Added to"} favourite list`),
            {
                autoClose: 1000,
            }
        );
    };

    const handleReaction = (e) => {
        e.stopPropagation();
        if (user?.user_id) {
            if (!isLiked) submitReaction();
            else new window.bootstrap.Modal(modalRef.current).show();
        } else navigate("/sign-in");
    };

    const handleModalConfirm = () => {
        window.bootstrap.Modal.getInstance(modalRef.current).hide();
        if (is_favourite) dispatch(removeFavourite(propertyId));
        submitReaction();
    };

    const handleModalCancel = () => {
        window.bootstrap.Modal.getInstance(modalRef.current).hide();
    };

    useEffect(() => {
        // isAuthenticated &&
        //     SocketService.send("leavePropertyRoom", {
        //         property_id: propertyId,
        //     });

        // // Join the socket room
        // !isAuthenticated
        //     ? SocketService.send("joinPropertyRoom", {
        //           property_id: propertyId,
        //       })
        //     : SocketService.send("joinPropertyRoom", {
        //           property_id: propertyId,
        //           user_id: user?.user_id,
        //       });

        SocketService.on("checkBid", ({ error, data }) => {
            if (!error) setOfferedUserId(data?.offerer_user_id);
            if (!error && propertyDetail?.seller_status_id === 27) {
                setPurchaseForefitStatus(data?.purchase_forefit_status);
                setPropertyCurrentStatus(
                    getPropertyStatus(
                        data?.listing_status_id,
                        data?.start_time_left_hr,
                        data?.time_left_hr,
                        data?.reserve_amount <= data?.high_bid_amt,
                        isSeller
                    )
                );
                const is_selected_highest_bid = data?.is_selected_highest_bid;
                const isReserveMet =
                    data?.reserve_amount !== undefined &&
                    data?.high_bid_amt !== undefined
                        ? data.reserve_amount <= data.high_bid_amt
                        : false;

                if (
                    data?.time_left_hr < 0 &&
                    data?.my_max_bid_val &&
                    isSeller === 0
                ) {
                    setStatusMessage(
                        isReserveMet || is_selected_highest_bid
                            ? data.max_bidder_user_id === Number(user?.user_id)
                                ? 1
                                : 0
                            : 2
                    );
                }
            }
        });
    }, [isConnected]);

    const handleSellerCotact = () => {
        !isAuthenticated &&
            toast.info(t("Please sign in to contact the seller."));

        const sellerData = {
            name: listed_by?.first_name,
            property_id: propertyId,
            seller_id: agent_id,
            profile_image: listed_by?.profile_image,
            is_chat_initiated: is_chat_initiated,
        };
        dispatch(setSellerDetail(sellerData));
        if (!sellerData.is_chat_initiated) {
            dispatch(setIsChatInitiated(1));
        } else {
            dispatch(setIsChatInitiated(2));
        }
        dispatch(handleSelectedUser(""));
        dispatch(handleChat([]));
        !isAuthenticated
            ? navigate("/sign-in?redirect=/inbox")
            : navigate("/inbox");
    };

    const validateValuationRequest = () => {
        if (!isAuthenticated) {
            navigate("/sign-in?redirect=/inbox");
            return;
        }
        if (!valuation_report_uploaded) {
            toast.error("Valuation report file not uploaded");
            return;
        }
        if (valuation_fee && !valuation_fee_paid) {
            dispatch(
                initiatePurchase({
                    property_id: propertyId,
                    amount: valuation_fee,
                    udf6: 5,
                    purchaseType: "normal",
                    udf7: "yes",
                    is_vat_commission_applicable: true,
                })
            );
            return;
        }
        if (propertyId) dispatch(sendValuationDocument(propertyId, "", t));
    };

    const isFromMyAuctions = isSeller === 1 && from === "/my-auctions";
    return (
        <React.Fragment>
            {showTabs && (
                <div className={`scroll-tabs ${showTabs ? "visible" : ""}`}>
                    <ScrollTabs />
                </div>
            )}

            <section className="details-wrap pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <Gallery
                                images={[
                                    ...(property_pic?.map((img) => img) || []),
                                    ...(property_video?.map((vid) => vid) ||
                                        []),
                                ]}
                                isFromMyAuctions={isFromMyAuctions}
                                floorPlan={floorPlan}
                            />

                            {(statusMessage !== 0 ||
                                (purchaseForefitStatus ||
                                    purchase_forefit_status) === 2 ||
                                String(offerUserId) === user?.user_id) && (
                                <div
                                    className={`alert alert-${statusMessage === 1 || String(offerUserId) === user?.user_id ? "success" : (purchaseForefitStatus || purchase_forefit_status) === 2 ? "skylight" : "danger"}`}
                                >
                                    {`${statusMessage === 1 || String(offerUserId) === user?.user_id ? (purchaseForefitStatus || purchase_forefit_status === 1 || String(offerUserId) === user?.user_id ? t("Sold! Your highest bid won the property. Our representative will contact you to proceed.") : t("You Won The Highest Bid")) : (purchaseForefitStatus || purchase_forefit_status) === 2 ? t("Forfeit request placed successfully") : t("Auction is closed and the property is pending review.")}`}
                                </div>
                            )}

                            <div className="product-details space">
                                <div className="tags-box">
                                    <div className="tags">
                                        <ul>
                                            {isSeller === 1 &&
                                                Number(property_for) === 2 && (
                                                    <li className="redclr">
                                                        {t("Live")}
                                                    </li>
                                                )}
                                            {property_for === 2 ? (
                                                <li
                                                    className={
                                                        getLotStatus(
                                                            session_status?.status_id,
                                                            lot_status?.status_id,
                                                            lot_pause_resume,
                                                            "",
                                                            true
                                                        )?.className
                                                    }
                                                >
                                                    {t(
                                                        getLotStatus(
                                                            session_status?.status_id,
                                                            lot_status?.status_id,
                                                            lot_pause_resume,
                                                            "",
                                                            true
                                                        )?.label
                                                    ) || ""}
                                                </li>
                                            ) : (
                                                <li
                                                    className={
                                                        propertyCurrentStatus?.className
                                                    }
                                                >
                                                    {t(
                                                        propertyCurrentStatus?.label
                                                    ) || ""}
                                                </li>
                                            )}

                                            {construction_status_name && (
                                                <li className="blueclr">
                                                    {t(
                                                        construction_status_name
                                                    )}
                                                </li>
                                            )}
                                            {/* ADREC: residential/unit feature tags
                                                (e.g. "Rare Find", "High Floor") removed — not
                                                applicable to land plots.
                                            {tags.map((tag, index) => (
                                                <li className="blueclr" key={index}>
                                                    <img src={tag icon} alt="" />
                                                    {t(tag.label) || ""}
                                                </li>
                                            ))}
                                            */}

                                            {/* <li className="grayclr">
                                                <img src="/img/bank.svg" alt="" /> {t("Bank Owned")}
                                            </li> */}
                                            {propertyDetail?.property_for ===
                                                2 &&
                                            getLotStatus(
                                                session_status?.status_id,
                                                lot_status?.status_id,
                                                lot_pause_resume,
                                                "",
                                                true
                                            )?.label === "Active" ? (
                                                <li className="live">
                                                    <em></em> {t("Live Room")}
                                                </li>
                                            ) : (
                                                <></>
                                            )}
                                            {/* visiblity 2 for private auction and 1 for normal auction */}
                                            {property_auction_data[0]
                                                ?.visibility === 2 ? (
                                                <li className="private">
                                                    <i className="fa-solid fa-user-lock"></i>{" "}
                                                    {t("Private Auction")}
                                                </li>
                                            ) : (
                                                <></>
                                            )}
                                        </ul>
                                    </div>
                                    {/* ADREC: Favorite (heart) and Share icons
                                        removed from the land-plot auction details page.
                                    <div className="tags-types">
                                        <ul>
                                            {isSeller === 0 && (
                                                <li>
                                                    <ShareButton ... />
                                                </li>
                                            )}
                                            {!isFromMyAuctions && (
                                                <li>
                                                    <button onClick={handleReaction}>
                                                        <img src={heart icon} alt="" />
                                                    </button>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                    */}
                                    {is_map_view && (
                                        <button
                                            onClick={() => openGoogleMaps()}
                                            style={{ color: "#027BFF" }}
                                            className="map-view-btn"
                                        >
                                            <img
                                                src="/img/map-icon-blue.svg"
                                                alt=""
                                                className="mr4"
                                            />
                                            {t("Map View")}
                                        </button>
                                    )}
                                </div>
                                <h3 className="mb0">
                                    {lang === "en"
                                        ? property_name
                                        : property_name_ar || ""}
                                </h3>
                                <div className="location">
                                    <span className="map-icon">
                                        <img src="/img/map-icon.svg" alt="" />
                                    </span>
                                    {t(
                                        lang === "en" ? municipality : municipality_ar
                                    )}
                                    ,{" "}
                                    {t(
                                        lang === "en" ? district : district_ar
                                    )}
                                    ,{" "}
                                    {t(
                                        lang === "en" ? community : community_ar
                                    )}
                                </div>

                                <div className="types">
                                    <ul>
                                        {/* ADREC: Bedrooms & Bathrooms removed — not
                                            applicable to land plots (they render "undefined").
                                            Only the plot area is kept below.
                                        <li>
                                            <img src="/img/bed-icon.svg" alt="" /> beds ...
                                        </li>
                                        <li>
                                            <img src="/img/bath-icon.svg" alt="" /> baths ...
                                        </li>
                                        */}
                                        <li>
                                            <img
                                                src="/img/ruler-icon.svg"
                                                alt=""
                                            />{" "}
                                            {square_footage || 0}
                                            <span>{t("Square Feet")}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div>
                                {isFromMyAuctions &&
                                    user?.user_id &&
                                    isSeller === 1 &&
                                    biddingData && (
                                        <BidHistory
                                            propertyId={propertyId}
                                            auctionStatus={auctionStatus}
                                            biddingData={biddingData}
                                        />
                                    )}
                            </div>

                            <div className="description-box" id="description">
                                <div className="space">
                                    <h6>{t("Description")}</h6>

                                    <div className="position-relative">
                                        <div
                                            ref={descRef}
                                            dir={lang === "en" ? "ltr" : "rtl"}
                                            style={{
                                                maxHeight: isExpanded
                                                    ? "none"
                                                    : "96px",
                                                overflow: "hidden",
                                                position: "relative",
                                                transition:
                                                    "max-height 0.3s ease",
                                                textAlign:
                                                    lang === "en"
                                                        ? "left"
                                                        : "right",
                                                overflowWrap: "break-word",
                                                wordBreak: "break-word",
                                            }}
                                            dangerouslySetInnerHTML={sanitizedDescription()}
                                        />

                                        {/* Fade Effect */}
                                        {!isExpanded && showButton && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    height: "40px",
                                                    background:
                                                        "linear-gradient(to bottom, rgba(255,255,255,0), #fff)",
                                                }}
                                            />
                                        )}
                                    </div>

                                    {showButton && (
                                        <button
                                            onClick={() =>
                                                setIsExpanded(!isExpanded)
                                            }
                                            className="scroll-link"
                                        >
                                            {isExpanded
                                                ? t("Read Less")
                                                : t("Read More")}
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* ADREC: the Amenities, Get More Details, Services,
                                Map View, Analytics Area, Buying-with-brand and
                                Similar Properties sections were removed from the
                                property detail page. Each one is preserved verbatim
                                as a commented block, immediately below or at its own
                                original position further down this file.

                                They use `{` + `//` line comments rather than a JSX
                                block comment because Amenities and Map View contain
                                their own JSX comments, and that inner close would
                                terminate an enclosing block comment. To restore a
                                section, strip the leading `//` from its lines and
                                drop the wrapping braces. */}

                            {
                                // ADREC: "Amenities" section removed from the property detail page.
                                // Commented out rather than deleted so it can be restored verbatim.
                                //                             <div className="additional-details space">
                                //                                 {/* <h5>{t("Additional Details")}</h5> */}
                                //                                 <h5>{t("Amenities")}</h5>
                                //
                                //                                 <ul className="amenities">
                                //                                     {amenities?.length > 0 ? (
                                //                                         <>
                                //                                             {(isAmenitiesExpanded
                                //                                                 ? amenities
                                //                                                 : amenities.slice(0, 9)
                                //                                             ).map((amenity, index) => (
                                //                                                 <li key={index}>
                                //                                                     {t(amenity?.feature_name)}
                                //                                                 </li>
                                //                                             ))}
                                //
                                //                                             {amenities.length > 9 && (
                                //                                                 <li>
                                //                                                     <button
                                //                                                         className="link"
                                //                                                         onClick={() =>
                                //                                                             setIsAmenitiesExpanded(
                                //                                                                 !isAmenitiesExpanded
                                //                                                             )
                                //                                                         }
                                //                                                     >
                                //                                                         {t(
                                //                                                             isAmenitiesExpanded
                                //                                                                 ? "View Less Amenities"
                                //                                                                 : "View All Amenities"
                                //                                                         )}
                                //                                                     </button>
                                //                                                 </li>
                                //                                             )}
                                //                                         </>
                                //                                     ) : (
                                //                                         <li>{t("No Amenities")}</li>
                                //                                     )}
                                //                                 </ul>
                                //                                 {/* <div className="add-item">
                                //                                     {projectData?.developer_name && (
                                //                                         <div className="block">
                                //                                             <h6>
                                //                                                 <span>{t("Developer")}</span>
                                //                                                 {t(
                                //                                                     projectData?.developer_name
                                //                                                 ) || ""}
                                //                                             </h6>
                                //                                         </div>
                                //                                     )}
                                //                                     {construction_status_name !== "Ready" &&
                                //                                         (project_name || project_name_ar) ? (
                                //                                         <div className="block">
                                //                                             <h6>
                                //                                                 <span>
                                //                                                     {t("Handover Date")}
                                //                                                 </span>
                                //                                                 {guessDateTime(
                                //                                                     projectData?.completion_date,
                                //                                                     "DD-MM-YYYY",
                                //                                                     0,
                                //                                                     lang
                                //                                                 )}
                                //                                             </h6>
                                //                                         </div>
                                //                                     ) : (
                                //                                         <></>
                                //                                     )}
                                //                                     <div className="block">
                                //                                         <h6>
                                //                                             <span>{t("Project")}</span>
                                //                                             {t(
                                //                                                 lang === "en"
                                //                                                     ? project_name
                                //                                                     : project_name_ar || ""
                                //                                             ) || t("Not Applicable")}
                                //                                         </h6>
                                //                                     </div>
                                //                                     <div className="block">
                                //                                         <h6>
                                //                                             <span>{t("Added Date")}</span>
                                //                                             {guessDateTime(
                                //                                                 added_on,
                                //                                                 "DD-MM-YYYY",
                                //                                                 0,
                                //                                                 lang
                                //                                             )}
                                //                                         </h6>
                                //                                     </div>
                                //                                     <div className="block">
                                //                                         <h6>
                                //                                             <span>{t("Auction ID")}</span>
                                //                                             {t(
                                //                                                 property_auction_data?.[0]
                                //                                                     ?.auction_unique_id
                                //                                             )}
                                //                                         </h6>
                                //                                     </div>
                                //                                 </div> */}
                                //                             </div>
                            }

                            {
                                // ADREC: "Get More Details" section removed from the property detail page.
                                // Commented out rather than deleted so it can be restored verbatim.
                                //                             <div className="contact-seller-wrap space">
                                //                                 <h5>{t("Get More Details")}</h5>
                                //
                                //                                 <div className="visit">
                                //                                     <div className="profile">
                                //                                         <div className="img">
                                //                                             <img
                                //                                                 src="/img/calendar-pink.svg"
                                //                                                 alt="calendar"
                                //                                             />
                                //                                         </div>
                                //                                         <h6 className="name">
                                //                                             {t("View property section title")}
                                //                                             <span>
                                //                                                 {t(
                                //                                                     "Interested in this property? Request a viewing and pick a time that suits you"
                                //                                                 )}
                                //                                             </span>
                                //                                         </h6>
                                //                                     </div>
                                //                                     <div className="contact">
                                //                                         <button
                                //                                             className="btn btn-primary btn-xs"
                                //                                             onClick={() => {
                                //                                                 if (!isAuthenticated) {
                                //                                                     navigate(
                                //                                                         "/sign-in?redirect=/inbox"
                                //                                                     );
                                //                                                     return;
                                //                                                 }
                                //                                                 setShowModal(true);
                                //                                             }}
                                //                                         >
                                //                                             {t("Schedule a Visit")}
                                //                                         </button>
                                //                                     </div>
                                //                                     <TimeSlotModal
                                //                                         show={showModal}
                                //                                         onClose={() => setShowModal(false)}
                                //                                         onHandleSubmit={({ slot }) =>
                                //                                             dispatch(
                                //                                                 setPreferredTime(
                                //                                                     propertyId,
                                //                                                     slot
                                //                                                 )
                                //                                             )
                                //                                         }
                                //                                     />
                                //                                 </div>
                                //
                                //                                 <div className="sellerBlock">
                                //                                     <div className="profile">
                                //                                         <div className="img">
                                //                                             <img
                                //                                                 // src="/img/profile.svg"
                                //                                                 src={`${
                                //                                                     listed_by?.profile_image
                                //                                                         ?.bucket_name &&
                                //                                                     listed_by?.profile_image
                                //                                                         ?.doc_file_name
                                //                                                         ? `${process.env.REACT_APP_AZURE_BLOB_URL}${listed_by.profile_image.bucket_name}/${listed_by.profile_image.doc_file_name}`
                                //                                                         : "/img/profile.svg"
                                //                                                 }`}
                                //                                                 alt=""
                                //                                             />
                                //                                         </div>
                                //
                                //                                         <h6 className="name">
                                //                                             {`${t(listed_by?.first_name)} ${t(listed_by?.last_name !== "NA" ? listed_by?.last_name : "" || "")}`}
                                //                                             <span>{t("Seller")}</span>
                                //                                         </h6>
                                //                                     </div>
                                //                                     <div className="contact">
                                //                                         <Link
                                //                                             className="btn btn-white btn-xs"
                                //                                             to=""
                                //                                             onClick={() =>
                                //                                                 (window.location.href = `tel:${listed_by?.phone_no || ""}`)
                                //                                             }
                                //                                         >
                                //                                             <img src="/img/phone.svg" alt="" />{" "}
                                //                                             {t("Call")}
                                //                                         </Link>
                                //                                         <button
                                //                                             className="btn btn-white btn-xs"
                                //                                             onClick={() => handleSellerCotact()}
                                //                                             disabled={
                                //                                                 Number(user?.user_id) ===
                                //                                                 agent_id
                                //                                                     ? true
                                //                                                     : false
                                //                                             }
                                //                                         >
                                //                                             <img
                                //                                                 src="/img/message.svg"
                                //                                                 alt=""
                                //                                             />{" "}
                                //                                             {t("Message")}
                                //                                         </button>
                                //                                     </div>
                                //                                 </div>
                                //                             </div>
                            }

                            {
                                // ADREC: "Services" section removed from the property detail page.
                                // Commented out rather than deleted so it can be restored verbatim.
                                //                             <div className="services-box space">
                                //                                 <h5>{t("Services")}</h5>
                                //                                 <ul>
                                //                                     <li>
                                //                                         <div className="pic">
                                //                                             <img
                                //                                                 src="/img/valuation-report.svg"
                                //                                                 alt=""
                                //                                             />
                                //                                         </div>
                                //                                         <div className="content">
                                //                                             <h6>{t("Valuation Report")}</h6>
                                //                                             <p>
                                //                                                 {t(
                                //                                                     "Get an estimated market value for this property"
                                //                                                 )}
                                //                                             </p>
                                //                                             <button
                                //                                                 className="btn btn-white btn-xs"
                                //                                                 onClick={
                                //                                                     validateValuationRequest
                                //                                                 }
                                //                                             >
                                //                                                 {t("Request Valuation")}
                                //                                             </button>
                                //                                         </div>
                                //                                     </li>
                                //                                     <li>
                                //                                         <div className="pic">
                                //                                             <img
                                //                                                 src="/img/inspection-report.svg"
                                //                                                 alt=""
                                //                                             />
                                //                                         </div>
                                //                                         <div className="content">
                                //                                             <h6>{t("Inspection Report")}</h6>
                                //                                             <p>
                                //                                                 {t(
                                //                                                     "Get a detailed inspection report for this property"
                                //                                                 )}
                                //                                             </p>
                                //                                             <button
                                //                                                 className="btn btn-white btn-xs"
                                //                                                 onClick={() => {
                                //                                                     const report =
                                //                                                         inspection_report?.[0];
                                //                                                     report
                                //                                                         ? downloadFile(
                                //                                                               `${process.env.REACT_APP_AZURE_BLOB_URL}${report.bucket_name}/${report.doc_file_name}`
                                //                                                           )
                                //                                                         : toast.info(
                                //                                                               t(
                                //                                                                   "No inspection report found"
                                //                                                               )
                                //                                                           );
                                //                                                 }}
                                //                                             >
                                //                                                 {t("Download Inspection")}
                                //                                             </button>
                                //                                         </div>
                                //                                         <div className="statuss">
                                //                                             <span className="alert alert-success">
                                //                                                 {t("Free")}
                                //                                             </span>
                                //                                         </div>
                                //                                     </li>
                                //                                 </ul>
                                //                             </div>
                            }

                            {/* 
                            <div className="inspection-report space">
                                <h5>{t("Inspection Report")}</h5>
                                <ul>
                                    <li>
                                        {t("Download Inspection Report")}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const report = inspection_report?.[0];
                                                report
                                                    ? downloadFile(
                                                        `${process.env.REACT_APP_AZURE_BLOB_URL}${report.bucket_name}/${report.doc_file_name}`
                                                    )
                                                    : toast.info(t("No inspection report found"));
                                            }}

                                            className="download-btn"
                                        >
                                            <img src="/img/download-icon.svg" alt="Download report" />
                                        </button>

                                    </li>

                                </ul>
                            </div>

                            <div className="inspection-report space">
                                <h5>{t("Valuation report")}</h5>
                                <ul>
                                    <li>
                                        {t("Request property valuation report")}
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={validateValuationRequest}
                                        >
                                            {t("Request valuation")}
                                        </button>

                                    </li>

                                </ul>
                            </div> */}

                            {/* <div className="inspection-report space"> */}
                            {/* <h5>{t("View property")}</h5> */}
                            {/* <ul>
                                    <li>
                                        View property on site
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                        >
                                            Request Visit
                                        </button>

                                    </li>
                                </ul> */}

                            {/* <ul>
                                    <li>
                                        {t("View property on site")}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (!isAuthenticated) {
                                                    navigate("/sign-in?redirect=/inbox")
                                                    return;
                                                }
                                                setShowModal(true)
                                            }}
                                            className="btn btn-primary btn-sm"
                                        >
                                            {t("Select prefered time")}
                                        </button>
                                        <TimeSlotModal
                                            show={showModal}
                                            onClose={() => setShowModal(false)}
                                            onHandleSubmit={({ slot }) => dispatch(setPreferredTime(propertyId, slot))}
                                        />
                                    </li>
                                </ul> */}
                            {/* </div> */}

                            <div className="fee-details space" id="reports">
                                <h5>{t("Fees & Charges")}</h5>
                                <ul>
                                    <li>
                                        <div className="name">
                                            {t("Service Fee")}
                                        </div>
                                        <h6>
                                            <Trans
                                                i18nKey="serviceFeeText"
                                                values={{
                                                    fee: property_setting?.service_fee,
                                                }}
                                                components={[<></>, <span />]}
                                            />
                                        </h6>
                                    </li>

                                    <li>
                                        <div className="name">
                                            {t("Deposit")}
                                        </div>
                                        <h6>
                                            <Trans
                                                i18nKey="depositText"
                                                values={{
                                                    amount: formatNumber(
                                                        deposit_amount,
                                                        lang
                                                    ),
                                                }}
                                                components={[
                                                    <strong key="amount" />,
                                                    <span key="text" />,
                                                ]}
                                            />
                                        </h6>
                                    </li>

                                    {Number(property_setting?.auction_fee) ? (
                                        <li>
                                            <div className="name">
                                                {t("Auction Fee")}
                                            </div>

                                            <h6>
                                                <Trans
                                                    i18nKey="auctionFeeText"
                                                    values={{
                                                        amount: formatNumber(
                                                            property_setting?.auction_fee,
                                                            lang
                                                        ),
                                                    }}
                                                    components={[
                                                        <strong key="amount" />,
                                                        <span key="text" />,
                                                    ]}
                                                />
                                            </h6>
                                        </li>
                                    ) : null}

                                    {/* <li>
                                        <span>{t("Service Fee")}:</span>{" "}
                                        {t("Service Fee Percentage", {
                                            serviceFeePercentage:
                                                property_setting?.service_fee,
                                        })}
                                    </li> */}
                                    {/* <li>
                                        <span>{t("Deposit")}:</span>
                                        {` ${t("Amount", {
                                            amount: formatNumber(
                                                deposit_amount,
                                                lang
                                            ),
                                        })} `}
                                        {t(
                                            "refundable if your bid is not successful"
                                        )}
                                    </li>
                                    <li>
                                        <span>{t("Auction Fee")}:</span>
                                        {` ${t("Amount", {
                                            amount: formatNumber(
                                                property_setting?.auction_fee,
                                                lang
                                            ),
                                        })} ${t("non-refundable")}`}
                                    </li> */}
                                </ul>
                            </div>

                            {/* <section id="history">
                                {user?.user_id && isSeller === 0 && (
                                    // <BidHistory
                                    //     propertyId={propertyId}
                                    //     auctionStatus={auctionStatus}
                                    //     isBidder={biddingData?.my_max_bid_val}
                                    //     start_date={biddingData?.start_date}
                                    //     end_date={biddingData?.end_date}
                                    //     show_reverse_not_met={
                                    //         property_setting
                                    //             ? property_setting?.show_reverse_not_met
                                    //             : false
                                    //     }
                                    //     isReserveMet={isReserveMet}
                                    //     isForeFitted={isForeFitted}
                                    //     biddingData={biddingData}
                                    // />
                                    <BidHistory
                                        propertyId={propertyId}
                                        auctionStatus={auctionStatus}
                                        biddingData={biddingData}
                                        attribute={{ colSpan: 3 }}
                                    />
                                )}
                            </section> */}

                            {
                                // ADREC: "Map View" section removed from the property detail page.
                                // Commented out rather than deleted so it can be restored verbatim.
                                //                             <div className="map-view space">
                                //                                 <section id="map">
                                //                                     <h5>{t("Map View")}</h5>
                                //                                     <div className="map">
                                //                                         {/* <iframe className="embed-map-frame" width={'100%'} height={'400'} frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://maps.google.com/maps?width=600&height=400&hl=en&q=dubai&t=&z=14&ie=UTF8&iwloc=B&output=embed"></iframe> */}
                                //                                         <DetailsMapComponent
                                //                                             property_name={property_name || ""}
                                //                                             muncipality={muncipality || ""}
                                //                                             state={state || ""}
                                //                                             country={country || ""}
                                //                                             district={district || ""}
                                //                                         />
                                //                                     </div>
                                //                                 </section>
                                //                                 {/* <ul>
                                //                                     <li>
                                //                                         View property on site
                                //                                         <button
                                //                                             type="button"
                                //                                             onClick={() => setShowModal(true)}
                                //                                             className="btn btn-primary btn-sm"
                                //                                         >
                                //                                             Select prefered time
                                //                                         </button>
                                //                                         <TimeSlotModal
                                //                                             show={showModal}
                                //                                             onClose={() => setShowModal(false)}
                                //                                         />
                                //                                     </li>
                                //                                 </ul> */}
                                //                             </div>
                            }

                            {
                                // ADREC: "Analytics Area" section removed from the property detail page.
                                // Commented out rather than deleted so it can be restored verbatim.
                                //                             {Number(city) === ABUDHABICITYID && (
                                //                                 <div
                                //                                     className={
                                //                                         noDataAreaComparison &&
                                //                                         noDataSaleTrends &&
                                //                                         noDataAveragePrice
                                //                                             ? ""
                                //                                             : "analytics-wrap space"
                                //                                     }
                                //                                     id="analytics"
                                //                                 >
                                //                                     {noDataAreaComparison &&
                                //                                     noDataSaleTrends &&
                                //                                     noDataAveragePrice ? (
                                //                                         <></>
                                //                                     ) : (
                                //                                         <h5>{t("Analytics Area")}</h5>
                                //                                     )}
                                //                                     <AreaComparision />
                                //                                     <SaleTrendChart />
                                //                                     <AveragePriceChart />
                                //                                 </div>
                                //                             )}
                            }

                            {
                                // ADREC: "Buying with <brand>" section removed from the property detail page.
                                // Commented out rather than deleted so it can be restored verbatim.
                                //                             <div
                                //                                 className="buying-mazad space"
                                //                                 id={"whyPropify"}
                                //                             >
                                //                                 <h4>
                                //                                     {t("Buying with")}{" "}
                                //                                     <img
                                //                                         src="/img/logo-f.svg"
                                //                                         alt="Propify Logo"
                                //                                         width={"140px"}
                                //                                     />
                                //                                 </h4>
                                //
                                //                                 <p className="text">
                                //                                     <Trans
                                //                                         i18nKey="mazad_users_description"
                                //                                         components={{ br: <br /> }}
                                //                                     />
                                //                                 </p>
                                //
                                //                                 <Faq faq={buying_with_mazad} />
                                //                             </div>
                            }

                            {/* ADREC: Mortgage Calculator removed — not applicable
                                to land-plot auctions (tab, section, and calc wiring removed).
                            <div id="mortgage">
                                <MortgageCalculator ...props... />
                            </div>
                            */}

                            <div
                                className="disclaimer-tabs space"
                                id={"licenseInformation"}
                            >
                                <ul
                                    className="nav nav-pills"
                                    id="pills-tab1"
                                    role="tablist"
                                >
                                    <li
                                        className="nav-item"
                                        role="presentation"
                                    >
                                        <button
                                            className="nav-link active"
                                            id="tab-regular"
                                            type="button"
                                            data-bs-toggle="tab"
                                            data-bs-target="#disclaimer"
                                            onClick={() =>
                                                setActiveTab("disclaimer")
                                            }
                                        >
                                            {t("Disclaimer")}
                                        </button>
                                    </li>
                                    <li
                                        className="nav-item"
                                        role="presentation"
                                    >
                                        <button
                                            className="nav-link"
                                            id="tab-live"
                                            type="button"
                                            data-bs-toggle="tab"
                                            data-bs-target="#license"
                                            onClick={() =>
                                                setActiveTab("license")
                                            }
                                        >
                                            {t("License Information")}
                                        </button>
                                    </li>
                                </ul>

                                <div
                                    className="tab-content"
                                    id="pills-tabContent1"
                                >
                                    <div
                                        className={`tab-pane fade ${activeTab === "disclaimer" ? "show active" : ""}`}
                                        id="disclaimer"
                                    >
                                        <div
                                            className="description"
                                            style={{ position: "relative" }}
                                        >
                                            <div
                                                ref={disclaimerRef}
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp:
                                                        isDisclaimerExpanded
                                                            ? "unset"
                                                            : 4,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    transition: "all 0.3s ease",
                                                }}
                                                dangerouslySetInnerHTML={sanitizedDisclaimer()}
                                            />

                                            {!isDisclaimerExpanded &&
                                                showDisclaimerButton && (
                                                    <div
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            bottom: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "40px",
                                                            background:
                                                                "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)",
                                                        }}
                                                    />
                                                )}
                                        </div>

                                        {(showDisclaimerButton ||
                                            isDisclaimerExpanded) && (
                                            <button
                                                onClick={() =>
                                                    setIsDisclaimerExpanded(
                                                        !isDisclaimerExpanded
                                                    )
                                                }
                                                className="scroll-link"
                                            >
                                                {isDisclaimerExpanded
                                                    ? t("Read Less")
                                                    : t("Read More")}
                                            </button>
                                        )}
                                    </div>

                                    <div
                                        className={`tab-pane fade ${activeTab === "license" ? "show active" : ""}`}
                                        id="license"
                                    >
                                        <div
                                            className="description"
                                            style={{ position: "relative" }}
                                        >
                                            <div
                                                ref={licenseRef}
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp:
                                                        isLicenseExpanded
                                                            ? "unset"
                                                            : 4,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    transition: "all 0.3s ease",
                                                }}
                                                dangerouslySetInnerHTML={sanitizedLicense()}
                                            />

                                            {!isLicenseExpanded &&
                                                showLicenseButton && (
                                                    <div
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            bottom: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "40px",
                                                            background:
                                                                "linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)",
                                                        }}
                                                    />
                                                )}
                                        </div>

                                        {(showLicenseButton ||
                                            isLicenseExpanded) && (
                                            <button
                                                onClick={() =>
                                                    setIsLicenseExpanded(
                                                        !isLicenseExpanded
                                                    )
                                                }
                                                className="scroll-link"
                                            >
                                                {isLicenseExpanded
                                                    ? t("Read Less")
                                                    : t("Read More")}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {propertyDetail?.project_id && (
                                <div className="project-details-wrap space">
                                    <h6>{t("Project Details")}</h6>
                                    <div
                                        className="project-image"
                                        onClick={() =>
                                            window.open(
                                                `/project-detail/${createSlug(projectData?.id, projectData?.project_uri)}`,
                                                "_blank"
                                            )
                                        }
                                    >
                                        <figure>
                                            <img
                                                className="slide-fixed"
                                                src="/img/trans16x9.png"
                                                alt="Transparent"
                                            />
                                            <img
                                                className="slide-img"
                                                src={`${process.env.REACT_APP_AZURE_BLOB_URL}${projectData?.bucket_name || "developer_project_image"}/${projectData?.doc_file_name || "default_project.jpg"}`}
                                                alt="project-image"
                                            />
                                        </figure>
                                        <div className="project-banner-content">
                                            <div className="status">
                                                <a href="/link">
                                                    {t(
                                                        projectData?.project_status
                                                    )}
                                                </a>
                                            </div>
                                            <div className="living">
                                                <h4>
                                                    {t(
                                                        lang === "en"
                                                            ? projectData?.project_name
                                                            : projectData?.project_name_ar ||
                                                                  ""
                                                    )}
                                                </h4>
                                                <div className="livingContent">
                                                    <div className="block">
                                                        {t("Starting Price")}
                                                        <strong>
                                                            {t("Amount", {
                                                                amount: formatPrice(
                                                                    projectData?.starting_price,
                                                                    lang
                                                                ),
                                                            })}
                                                        </strong>
                                                    </div>
                                                    <div className="block">
                                                        {t("Property Type")}
                                                        <strong>
                                                            {projectData?.property_types
                                                                ?.map((item) =>
                                                                    t(`${item}`)
                                                                )
                                                                .join(" | ")}
                                                        </strong>
                                                    </div>
                                                    <div className="block">
                                                        {t("No. of Units")}
                                                        <strong>
                                                            {t(
                                                                projectData?.total_units
                                                            )}
                                                        </strong>
                                                    </div>
                                                </div>
                                                <div className="learnmore">
                                                    <div
                                                        // target="_blank"
                                                        // to={`/project-detail/${createSlug(projectData?.id, projectData?.project_uri)}`}
                                                        className="btn btn-blank btn-sm"
                                                    >
                                                        {t("Learn More")}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {
                                // ADREC: "Similar Properties" section removed from the property detail page.
                                // Commented out rather than deleted so it can be restored verbatim.
                                //                             <div id="similar">
                                //                                 <SimilarProperties />
                                //                             </div>
                            }
                        </div>
                        {
                            <Fragment>
                                {isFromMyAuctions &&
                                    propertyDetail?.seller_status_id ===
                                        SELLER_PROPERTY_STATUS[
                                            "ON_AUCTION"
                                        ] && (
                                        <AuctionBiddingSeller
                                            onDataChange={
                                                handleBidHistoryChange
                                            }
                                        />
                                    )}

                                {/* <div className="col-lg-12">
                                        <div
                                            className="bid-accordian accordion accordion-flush"
                                            id="accordionFlushExample"
                                        >
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button
                                                        className="accordion-button"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#ownership-collapseOne"
                                                        aria-expanded="true"
                                                        aria-controls="ownership-collapseOne"
                                                    >
                                                        {t("Additional Property Details")}
                                                    </button>
                                                </h2>
                                                <div
                                                    id="ownership-collapseOne"
                                                    className="accordion-collapse collapse show"
                                                    data-bs-parent="#accordionFlushExample"
                                                >
                                                    <div className="accordion-body">
                                                        <div className="additional-details space">
                                                            <div className="heading-text">
                                                                {t("Amenities")}
                                                            </div>

                                                            <ul className="amenities">
                                                                {amenities?.length > 0 ? (
                                                                    amenities?.map(
                                                                        (
                                                                            amenity,
                                                                            index
                                                                        ) => (
                                                                            <li key={index}>
                                                                                {t(
                                                                                    amenity?.feature_name
                                                                                )}
                                                                            </li>
                                                                        )
                                                                    )
                                                                ) : (
                                                                    <li>
                                                                        {t("No Amenities")}
                                                                    </li>
                                                                )}
                                                            </ul>

                                                            <div className="add-item">
                                                                {projectData?.developer_name && (
                                                                    <div className="block">
                                                                        <h6>
                                                                            <span>
                                                                                {t(
                                                                                    "Developer"
                                                                                )}
                                                                            </span>
                                                                            {t(
                                                                                projectData.developer_name
                                                                            )}
                                                                        </h6>
                                                                    </div>
                                                                )}
                                                                {construction_status_name !==
                                                                    "Ready" &&
                                                                    (project_name ||
                                                                        project_name_ar) && (
                                                                        <div className="block">
                                                                            <h6>
                                                                                <span>
                                                                                    {t(
                                                                                        "Handover Date"
                                                                                    )}
                                                                                </span>
                                                                                {guessDateTime(
                                                                                    projectData?.completion_date,
                                                                                    "DD-MM-YYYY",
                                                                                    0,
                                                                                    lang
                                                                                )}
                                                                            </h6>
                                                                        </div>
                                                                    )}
                                                                <div className="block">
                                                                    <h6>
                                                                        <span>
                                                                            {t("Project")}
                                                                        </span>
                                                                        {t(
                                                                            lang === "en"
                                                                                ? project_name
                                                                                : project_name_ar ||
                                                                                ""
                                                                        ) ||
                                                                            t(
                                                                                "Not Applicable"
                                                                            )}
                                                                    </h6>
                                                                </div>
                                                                <div className="block">
                                                                    <h6>
                                                                        <span>
                                                                            {t(
                                                                                "Added Date"
                                                                            )}
                                                                        </span>
                                                                        {guessDateTime(
                                                                            added_on,
                                                                            "DD-MM-YYYY",
                                                                            0,
                                                                            lang
                                                                        )}
                                                                    </h6>
                                                                </div>
                                                                <div className="block">
                                                                    <h6>
                                                                        <span>
                                                                            {t(
                                                                                "Auction ID"
                                                                            )}
                                                                        </span>
                                                                        {t(
                                                                            property_auction_data?.[0]
                                                                                ?.auction_unique_id
                                                                        )}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="space">
                                                            <h6>{t("Description")}</h6>
                                                            <div
                                                                dangerouslySetInnerHTML={sanitizedDescription()}
                                                            />
                                                        </div>

                                                        {Number(city) ===
                                                            ABUDHABICITYID && (
                                                                <div className="analytics-wrap space">
                                                                    <h6>
                                                                        {t("Analytics Area")}
                                                                    </h6>
                                                                    <AreaComparision />
                                                                    <div className="priceanalytic mb10">
                                                                        <h3>
                                                                            {t("Sale trend")}
                                                                        </h3>
                                                                        <p>
                                                                            {t(
                                                                                "View the listing price trends of similar properties"
                                                                            )}
                                                                        </p>
                                                                        <SaleTrendChart />
                                                                    </div>

                                                                    <div className="priceanalytic">
                                                                        <h3>
                                                                            {t("Average Price")}
                                                                        </h3>
                                                                        <p>
                                                                            {t(
                                                                                "View the average price trends of similar properties"
                                                                            )}
                                                                        </p>
                                                                        <AveragePriceChart />
                                                                    </div>
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                            </Fragment>
                        }
                        {isSeller === 0 &&
                            propertyDetail?.seller_status_id ===
                                SELLER_PROPERTY_STATUS["ON_AUCTION"] && (
                                <AuctionBidding
                                    onDataChange={handleBidHistoryChange}
                                />
                            )}
                    </div>
                </div>
                <div className="modal fade" ref={modalRef} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title">
                                    {t("Remove from favourite?")}
                                </h6>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p className="mb0 sky-text">
                                    {t(
                                        "Are you sure about removing it from your favourite collections?"
                                    )}
                                </p>
                            </div>
                            <div className="d-flex">
                                <button
                                    className="btn btn-sky btn-md width50"
                                    onClick={handleModalCancel}
                                >
                                    {t("Cancel")}
                                </button>
                                <button
                                    className="btn btn-primary btn-md width50"
                                    onClick={handleModalConfirm}
                                >
                                    {t("Remove")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <ContactUsModal
                    title={"Anything on your mind? Just reach out!"}
                    content={
                        "our support team is available 9am - 6pm Sunday to Saturday."
                    }
                    handleModalCancel={() =>
                        dispatch(handleContactUsModal(false))
                    }
                    handleModalOpen={() => dispatch(handleContactUsModal(true))}
                />
                {retractBidModal && (
                    <RetractBidModal
                        // show={() => dispatch(handleRetractBidModal(true))}
                        onClose={() => dispatch(handleRetractBidModal(false))}
                        // isRetractBid={isRetracted}
                        // setIsRetractBid={setIsRetracted}
                    />
                )}

                {showFailureModal && (
                    <PaymentFailureModal
                        show={showFailureModal}
                        onClose={() => setShowFailureModal(false)}
                        transactionId={reg_transaction_id}
                        failureMsg={
                            payment_failed_message ||
                            "Your payment could not be completed."
                        }
                        paymentErrorText={
                            payment_error_text ||
                            "The transaction failed due to a technical issue. Please try again or contact support."
                        }
                    />
                )}
            </section>
        </React.Fragment>
    );
};

export default Details;
